import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Segment,
  Tab,
  TabPane,
  Header,
  Grid,
  GridColumn,
  Table,
  Dropdown,
  Confirm,
  Icon,
  Popup,
} from "semantic-ui-react";
//import { Line } from "@ant-design/charts";
import { Pie, Column, DualAxes } from "@ant-design/plots";
import {
  Permission,
  // Effluentform,
  // Form,
  // Productionform,
} from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./EffluentKPIsDashBoard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { formatDateView } from "../../../../utils/formatDate";
import EffluentSummary from "./effluentSummary";
import TableGraf from "./TableGraf";

import { CollapsibleSection, LoadingSpinner } from "../../../Shared";
//import { Renderer as SVGRenderer } from '@antv/g-svg';

import {
  effluentKPIsCodes,
  effluentFormulasIndicators,
  determineEffluentUnits,
  effluentCodes,
  convertUnitsFinal,
} from "../../../../utils/dataAndFormulas/effluentForms";

import {
  formatValue,
  convertUnits,
} from "../../../../utils/dataAndFormulas/convert";

const permissionController = new Permission();
// const effluentController = new Effluentform();
// const formController = new Form();
// const productionController = new Productionform();

export function EffluentKPIsDashBoard(props) {
  const { site, sharedProductionForms, sharedWorkersByPeriod } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");
  const [valueBaseline, setValueBaseline] = useState({});
  const [indicatorsLineBase, setIndicatorsLineBase] = useState([]);

  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);
  const [configFormData, setConfigFormData] = useState(null);

  const [workersTotals, setWorkersTotals] = useState([]);

  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;
  const [lastYears, setLastYears] = useState({}); // resultados calculados
  const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados
  const [totalesProductionsByFilters, setTotalesProductionsByFilters] = useState({}); // resultados de producción por mes
  const [totalesWorkersByFilters, setTotalesWorkersByFilters] = useState({}); // resultados de trabajadores por mes

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

  //declaración estado de filtros
  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        effluentKPIsCodes.error(error);
        setPermissionsActive([]);
      } finally {
        stopLoading();
      }
    })();
  }, []);

  useEffect(() => {
    if (!site) return;

    const fetchData = async () => {
      startLoading();
      setData([]);
      setbaseline("");
       try {
        const currentYear = new Date().getFullYear();
        const yearsLast = Array.from({ length: 5 }, (_, i) =>
          String(currentYear - i)
        );

        // 🚀 Paralelizar consultas de baseline y datos iniciales
        const [prueba, responseBaseline] = await Promise.all([
          effluentController.getEffluentFormsByLineBaseYears(accessToken, site),
          formController.getLastBaselineByFormBySite(accessToken, site, "production"),
        ]);

        setIndicatorsLineBase(prueba.effluentForms.indicators);

        const yearsLineaBase = prueba.effluentForms.years;
        const yearsCombined = [...new Set([...yearsLineaBase, ...yearsLast])];

        // 🚀 Obtener datos de efluentes
        // Nota: El total de trabajadores por año se calcula desde getTotalWorkersByYearsAndPeriod
        // en el siguiente useEffect, igual que en los demás dashboards
        const responseEffluent = await effluentController.getEffluentFormsByLastYears(
          accessToken,
          site,
          yearsCombined
        );

        // Comentado: consulta redundante - el total de trabajadores se calcula desde datos por período
        // const totalWorkersByYear = await socialController.getTotalWorkersByYears(
        //   accessToken,
        //   site,
        //   yearsCombined
        // );

        setData(responseEffluent.effluentForms);
        // Comentado: se sobrescribe en el siguiente useEffect con el promedio calculado desde datos mensuales
        // setWorkersTotals(totalWorkersByYear.totalWorkers);

        // Procesar baseline
        if (responseBaseline.code === 200) {
          setbaseline(responseBaseline.baseline);

          const result = await Promise.all(
            Object.entries(responseBaseline.baseline)
              .filter(([anio, valor]) => valor !== null)
              .map(async ([anio, valor]) => {
                const a = await getValueBaseLine(anio, valor);
                return { [anio]: a };
              })
          );

          const resultadoFinal = result.reduce(
            (acc, obj) => ({ ...acc, ...obj }),
            {}
          );
          setValueBaseline(resultadoFinal);
        }
      } catch (error) {
        console.error("Error loading effluent data:", error);
        setData([]);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [site]);
console.log('🔴 Estado totalesWorkersByFilters:', totalesWorkersByFilters);
console.log('🔵 Estado workersTotals:', workersTotals);
console.log('🟡 Estado valueBaseline (valores numéricos):', valueBaseline);
console.log('🟠 Estado baseline (tipo VPS/VFS por año):', baseline);

  // Obtener configuración de campos activos del formulario
  useEffect(() => {
    (async () => {
      try {
        if (site) {
          const response = await formController.getFormsBySite(
            accessToken,
            site,
            "effluent",
            true
          );
          if (Array.isArray(response) && response.length > 0) {
            setConfigFormData(response[0]);
          } else {
            setConfigFormData(null);
          }
        }
      } catch (error) {
        console.error("Error al obtener configFormData:", error);
        setConfigFormData(null);
      }
    })();
  }, [site]);

  // Función que obtiene los campos fuente de un KPI basándose en effluentFormulasIndicators
  const getKPISourceFields = useCallback((kpiName) => {
    const kpiSourceMap = {
      'total_domestic_effluents_kpis': ['domestic_effluents'],
      'total_industrial_effluents_kpis': ['industrial_effluents'],
      'total_combined_effluents_kpis': ['combined_effluents'],
      'domestic_effluents_kpis': ['domestic_effluents'],
      'industrial_effluents_kpis': ['industrial_effluents'],
      'sludge_and_mud_kpis': ['sludge_and_mud'],
      'recycled_effluents_kpis': ['recycled_effluents'],
      'treatment_cost_domestic_effluents_kpis': ['treatment_cost_domestic_effluents'],
      'industrial_effluent_treatment_cost_kpis': ['industrial_effluent_treatment_cost'],
      'sludge_disposal_cost_kpis': ['sludge_disposal_cost'],
    };
    return kpiSourceMap[kpiName];
  }, []);

  // 🚀 Memoizar determinación de campos basándose en configFormData
  const determineFieldsKPIs = useMemo(() => {
    const fields = new Set();

    Object.keys(effluentKPIsCodes).forEach((key) => {
      const sourceFields = getKPISourceFields(key);

      // Si no tiene campos fuente definidos, agregarlo por defecto
      if (!sourceFields) {
        fields.add(key);
        return;
      }

      // Si hay configFormData, verificar si TODOS los campos fuente están activos
      if (configFormData?.fields && configFormData.fields.length > 0) {
        const allSourceFieldsActive = sourceFields.every(sourceFieldName => {
          const fieldConfig = configFormData.fields.find(f => f.name === sourceFieldName);
          return fieldConfig && fieldConfig.active !== false;
        });

        if (allSourceFieldsActive) {
          fields.add(key);
        }
      } else {
        // Si no hay configFormData, mostrar todos los campos (comportamiento por defecto)
        fields.add(key);
      }
    });

    return Array.from(fields);
  }, [configFormData, getKPISourceFields]);

  // 🚀 Memoizar campos de códigos
  const determineFieldsCode = useMemo(() => {
    const fields = new Set();

    Object.keys(effluentCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  }, []);

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        if (data && valueBaseline && sharedWorkersByPeriod && sharedProductionForms) {
          // Año actual
          const currentYear = new Date().getFullYear();

          // 🔹 Últimos 5 años dinámicos
          const lastFiveYears = [
            currentYear,
            currentYear - 1,
            currentYear - 2,
            currentYear - 3,
            currentYear - 4,
          ];

          // 🔹 Usar trabajadores compartidos desde DashBoard.js
          setTotalesWorkersByFilters(sharedWorkersByPeriod);

          // 🔹 Calcular promedio de trabajadores por año desde datos mensuales
          const avgWorkersByYear = {};
          const workersByPeriod = sharedWorkersByPeriod || {};
          for (const year in workersByPeriod) {
            const months = Object.values(workersByPeriod[year]);
            if (months.length > 0) {
              const sum = months.reduce((a, b) => a + b, 0);
              avgWorkersByYear[year] = Math.round(sum / months.length); // Promedio mensual
            } else {
              avgWorkersByYear[year] = 0;
            }
          }
          console.log('📈 Promedio trabajadores por año (desde meses):', avgWorkersByYear);
          setWorkersTotals(avgWorkersByYear); // Actualizar workersTotals con el promedio calculado

          const previous_totals = await transformData1(data); //separa por años los formularios
          calculateDataFinal(previous_totals, avgWorkersByYear); //calcula los totales finales indicadores, pasando el promedio

          // 🔹 Filtrar datos solo de esos 5 años
          const filteredByYears = data?.data
            ?.filter((item) => lastFiveYears.includes(Number(item.year))) // 👈 convierte el string
            ?.reduce((acc, item) => {
              const year = Number(item.year);
              if (!acc[year]) acc[year] = [];
              acc[year].push(item);
              return acc;
            }, {});

          // 🔹 Guardar solo años con al menos un mes cargado
          const yearsWithData = lastFiveYears.filter((year) =>
            data?.data?.some((item) => Number(item.year) === year)
          );
          setLastYears(yearsWithData);

          const results = await getLastThreeYearsData(filteredByYears);
          setTotalesByFilters(results);

          // Calcular producción por mes usando datos compartidos desde DashBoard.js
          const totalesFinal = await calcularVPSVFSporMesPorAño(sharedProductionForms, baseline);
          setTotalesProductionsByFilters(totalesFinal);
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [data, valueBaseline, sharedProductionForms, sharedWorkersByPeriod]);

  //Calcula el valor de linea base por año hay que cambiar si es por vfs o vps
  const getValueBaseLine = async (year, type) => {
    try {
      if (type === "VPS") {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_production"
          );
        //setValueBaseline(response1.total)
        return response1.total;
      } else {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_billing"
          );
        //setValueBaseline(response1.total)
        return response1.total;
      }
    } catch (error) {
      //console.error(error);
      return 1; /// Retorna uno por si hay error ver este tema
    }
  };

  //Funcion para obtener los valores de los campos por cada año
  const transformData1 = async (data) => {
    // Inicializar el objeto de totales y los conceptos
    const totalsPerYear = {};
    const conceptsSet = [];
    const unitsCache = {}; // Aquí almacenaremos los datos de unidades por año

    // Unidades configuradas en configFormData tienen prioridad máxima
    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    const fields = determineFieldsCode; // 🚀 Usar directamente el array memoizado

    // Verificar si data y data.data son válidos y contienen datos
    if (!data || !Array.isArray(data.data) || data.data.length === 0) {
      //console.log("No hay datos para procesar o data.data no es un array válido");
      return {}; // Retornar un objeto vacío o manejar el caso según se requiera
    }

    // Crear un array de años únicos de los datos de consumo
    const uniqueYears = [
      ...new Set(data.data.map((item) => String(item.year))),
    ];

    // Primero, obtener las unidades para todos los años requeridos
    //console.log('Obteniendo unidades para los años:', uniqueYears);
    const promises = uniqueYears.map(async (año) => {
      try {
        // Realizar la llamada para obtener las unidades para el año
        const units = await effluentController.getLastUnitFieldsByYear(
          accessToken,
          site,
          año,
          fields
        );

        // Guardar en el caché si las unidades son válidas
        if (units && units.fields) {
          unitsCache[año] = units;
          //console.log(`Unidades guardadas en caché para el año ${año}:`, units);
        } else {
          // console.log(`No se obtuvieron unidades válidas para el año ${año}`);
        }
      } catch (error) {
        //console.log(`Error al obtener unidades para el año ${año}:`, error);
      }
    });

    // Esperar a que todas las consultas de unidades se resuelvan
    await Promise.all(promises);

    // Ahora procesamos los datos de consumo usando las unidades en caché
    // console.log('Procesando los consumos');
    if (data.data !== undefined) {
      // Crear un array de promesas para manejar las llamadas asíncronas
      const consumptionPromises = data.data.map(async (item) => {
        const year = String(item.year);

        // Verificar si ya tenemos las unidades para este year en el caché
        const units = unitsCache[year];
        if (!units) {
          //console.log(`No se encontraron unidades para el year ${year} en el caché`);
          return;
        }

        // Iterar sobre los conceptos que tenemos en el item
        fields.forEach((concept) => {
          // Si el concepto existe, procesamos
          if (item[concept]) {
            // Añadir el concepto a la lista de concepts únicos
            conceptsSet.push(concept);

            // Inicializar el total para el year si no existe
            if (!totalsPerYear[concept]) {
              totalsPerYear[concept] = {};
            }

            // Inicializar el total para el year si no existe
            if (!totalsPerYear[concept][year]) {
              totalsPerYear[concept][year] = {
                total: 0,
                unit: configUnits[concept] || units.fields[concept] || item[concept]?.unit || "",
              };
            }

            // Sumar el valor de consumo
            totalsPerYear[concept][year].total += item[concept].value
              ? convertUnitsFinal(
                  item[concept].value,
                  item[concept].unit,
                  totalsPerYear[concept][year].unit,
                  concept
                )
              : 0;
          }
        });
      });
      // Esperar a que todas las promesas de consumo se resuelvan
      await Promise.all(consumptionPromises);
    }

    return totalsPerYear;
  };

  //Funcion para obtener los valores de los indicadores por cada año
  // avgWorkersByYearParam: parámetro opcional para pasar el promedio calculado desde datos mensuales
  const calculateDataFinal = async (totales, avgWorkersByYearParam = null) => {
    // Inicializar el objeto de totales y los conceptos

    const totalsFinal = { ...totales };
    const conceptsSet = [];
    // Usar el parámetro si se pasa, sino usar el estado workersTotals
    const workersDataToUse = avgWorkersByYearParam || workersTotals;
    // console.log(workersTotals)
    if (totales !== undefined) {
      for (let item in totales) {
        if (totales.hasOwnProperty(item)) {
          for (let year in totales[item]) {
            //const valueB = await getValueBaseLine(year, baseline[year]);
            const valueB = valueBaseline[year];

            if (totales[item].hasOwnProperty(year)) {
              const fields = determineFieldsKPIs; // 🚀 Usar directamente el array memoizado

              // Iterar sobre los conceptos que tenemos en el item
              fields.forEach((concept) => {
                // Añadir el concepto a la lista de conceptos únicos
                // Inicializar el total para el año si no existe
                if (!totalsFinal[concept]) {
                  totalsFinal[concept] = {};
                  conceptsSet.push(concept);
                }

                // Inicializar el total para el año si no existe
                if (!totalsFinal[concept][year]) {
                  totalsFinal[concept][year] = {};
                }

                totalsFinal[concept][year] = effluentFormulasIndicators(
                  concept,
                  year,
                  totalsFinal,
                  !valueB || valueB === 0 ? 1 : valueB,
                  workersDataToUse[year] // Usa promedio desde datos mensuales si se pasa
                );
              });
            }
          }
        }
      }
    }

    //setConceptos(removeNulls(totalsFinal, conceptsSet));

    setConceptos(conceptsSet);
    setTotales(totalsFinal);
  };
  // Función para obtener los valores de un año y mes específicos (period en texto)
  const getDataByYearAndMonth = async (data, year, month) => {
    const results = {};
    const fields = determineFieldsCode; // 🚀 Usar directamente el array memoizado
    const unitsCache = {};

    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    if (!data || !data || Object.keys(data).length === 0) {
      return {};
    }

    // Diccionario de meses
    const monthMap = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const yearStr = String(year);
    const monthStr =
      typeof month === "string"
        ? monthMap[month] || ""
        : String(month).padStart(2, "0");

    if (!monthStr) {
      console.warn("Mes inválido o no reconocido:", month);
      return {};
    }

    const yearData = data[yearStr];
    if (!Array.isArray(yearData)) {
      console.warn("No hay datos para el año:", yearStr);
      return {};
    }

    const filteredData = yearData.filter(
      (item) => monthMap[item.period] === monthStr
    );

    if (filteredData.length === 0) {
      console.warn(`No hay datos para ${month} ${yearStr}`);
      return {};
    }

    // Procesar resultados por campo
    filteredData.forEach((item) => {
      const units = unitsCache[yearStr];

      fields.forEach((concept) => {
        if (item[concept]) {
          if (!results[concept]) {
            results[concept] = {
              total: 0,
              unit: configUnits[concept] || units?.fields[concept] || item[concept]?.unit || "",
            };
          }

          results[concept].total += item[concept].value
            ? convertUnitsFinal(
                item[concept].value,
                item[concept].unit,
                results[concept].unit,
                concept
              )
            : 0;
        }
      });
    });

    // ==========================
    // 🔹 Calcular energía total (sin incluir costos)
    // ==========================

    // Lista de conceptos energéticos (sin costos)
    const effluentConcepts = Object.keys(effluentCodes).filter(
      (key) => !key.includes("cost")
    );

    let totalEffluentMonth = 0;
    let effluentUnit = "";

    effluentConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        totalEffluentMonth += results[concept].total;
        effluentUnit = results[concept].unit || effluentUnit;
      }
    });

    results.total_effluent_month = {
      total: totalEffluentMonth,
      unit: effluentUnit || "MWh",
    };

    // ==========================
    // 🔹 Calcular renovables
    // ==========================

    // ==========================
    // 🔹 Calcular electrica
    // ==========================
    return results;
  };

  // ==========================
  // 🔹 Calcular ultimos 3 años
  // ==========================

  const getLastThreeYearsData = async (totalesByFilters) => {
    const currentYear = new Date().getFullYear();
    const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const resultsByYear = {};

    for (const year of lastThreeYears) {
      resultsByYear[year] = {};

      for (const month of months) {
        const data = await getDataByYearAndMonth(totalesByFilters, year, month);
        resultsByYear[year][month] = data;
      }
    }

    return resultsByYear;
  };

  const removeNulls = (data, concepts) => {
    // Iterar sobre las claves externas
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        // Verificar si todos los valores internos son 0
        const allZero = Object.values(data[key]).every(
          (value) =>
            value.total === 0 || value.total === undefined || isNaN(value.total)
        );

        // Si todos los valores son 0, eliminar la clave externa
        if (allZero) {
          //delete concepts[key];
          concepts = concepts.filter((item) => item !== key);
        }
      }
    }
    return concepts;
  };

  async function calcularVPSVFSporMesPorAño(documentosPorAño, baselines) {

  const resultado = {};

  for (const [year, docs] of Object.entries(documentosPorAño)) {
    const baselineType = baselines[year]; // "VPS" o "VFS"
    if (!baselineType) continue;

    const isProduccion = baselineType === "VPS";
    const prefix = isProduccion ? "VP" : "VF";

    resultado[year] = {};

    for (const doc of docs) {
      const mes = doc.period;
      if (!mes) continue;

      let totalMes = 0;

      // Recorremos todos los campos del documento
      for (const [key, campo] of Object.entries(doc)) {
        // buscamos solo los campos dinámicos de producción o facturación
        if (campo?.code && campo.code.startsWith(prefix) && !campo.code.startsWith(prefix + "S")) {
          const value = Number(campo.value) || 0;
          const coef = Number(campo.standardized_coefficient) || 1;
          totalMes += value * coef;
        }
      }

      resultado[year][mes] = totalMes;
    }
  }

  return resultado;
}

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (
    !data ||
    !data.years ||
    data.years.length === 0 ||
    !conceptos ||
    conceptos.length === 0
  ) {
    return (
      <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
        <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
          <Icon name="exclamation triangle" size="huge" color="gray" />
        </div>
        <div
          style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
        >
          {t("no_data_available") || "No hay datos disponibles"}
        </div>
      </div>
    );
  } else {
    return (
      <div className="list-effluent-forms">
        {/* Sección de Resumen */}
        <div className="effluent-summary-section">
          <EffluentSummary
            filters={filters}
            site={site}
            valueBaseline={valueBaseline}
            effluentController={Effluentform}
            totales={totales}
            selectorSlot={<YearMonthSelector onChange={setFilters} />}
          />
        </div>

        {/* Sección de Gráficos */}
        <div className="effluent-tablegraf-section">
          <TableGraf filters={filters} totales={totales} t={t} site={site}/>
        </div>

        {/* Sección de Comparación - Industrial */}
        <CollapsibleSection
          title={t("industrial_effluents_evolution")}
          className="effluent-comparison-section"
        >
          <EffluentComparisonChartIndustrial resultsByYear={totalesByFilters} t={t}/>
        </CollapsibleSection>

        {/* Sección de Intensidad - Industrial */}
        <CollapsibleSection
          title={t("industrial_effluents_intensity")}
          className="effluent-intensity-section"
        >
          <EffluentMonthlyChartIndustrial resultsByYear={totalesByFilters} t={t} resultsProductions={totalesProductionsByFilters} valueBaseline={baseline}/>
        </CollapsibleSection>

        {/* Sección de Comparación - Doméstico */}
        <CollapsibleSection
          title={t("domestic_effluents_evolution")}
          className="effluent-comparison-section"
        >
          <EffluentComparisonChartDomestic resultsByYear={totalesByFilters} t={t} />
        </CollapsibleSection>

        {/* Sección de Intensidad - Doméstico */}
        <CollapsibleSection
          title={t("domestic_effluents_intensity")}
          className="effluent-intensity-section"
        >
          {/* <EffluentMonthlyChartDomestic resultsByYear={totalesByFilters} t={t} resultsProductions={totalesProductionsByFilters}/> */}
          <EffluentMonthlyChartDomestic resultsByYear={totalesByFilters} t={t} resultsProductions={totalesProductionsByFilters} resultsWorkers={totalesWorkersByFilters}/>
        </CollapsibleSection>

        {/* Sección de Tabla de Datos */}
        <CollapsibleSection
          className="effluent-table-section"
          header={
            <div className="effluent-table-col-header">
              <span className="col-code">{t("code")}</span>
              <span className="col-indicators">{t("indicators")}</span>
              <span className="col-years">
                {(data.years
                  ? [...data.years].sort((a, b) => b - a).slice(0, 5)
                  : []
                ).map((y) => (
                  <span key={y} className="col-year">{y}</span>
                ))}
              </span>
              <span className="col-lb">{t("LB")}</span>
              <span className="col-units">{t("units")}</span>
            </div>
          }
          defaultOpen={true}
        >
          <TableYears
            filters={filters}
            data={data}
            accessToken={accessToken}
            t={t}
            conceptos={conceptos}
            totales={totales}
            language={language}
            indicatorsLineBase={indicatorsLineBase}
            valueBaseline={valueBaseline}
          />
        </CollapsibleSection>

        {/* Sección de Valores Intermedios */}
        <IntermediateValuesDisplay
          resultsProductions={totalesProductionsByFilters}
          resultsWorkers={totalesWorkersByFilters}
          t={t}
        />
      </div>
    );
  }
}

// 🚀 Memoizar TableYears para evitar re-renders innecesarios
const TableYears = React.memo(function TableYears(props) {
  const {
    data,
    conceptos,
    totales,
    t,
    language,
    valueBaseline,
    indicatorsLineBase,
  } = props;

  const [years, setYears] = useState([]);
  const [months, setMoths] = useState([]);
  const [listConceptos, setListConceptos] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);

  // Función helper para convertir unidades automáticamente para mejor legibilidad
  const autoConvertToLiters = (value, unit) => {
    // Convertir m³ a litros si el valor es < 1 (empieza con 0,...)
    if (unit === "m3" && value < 1 && value > 0) {
      return {
        value: value * 1000, // Convertir m³ a litros (1 m³ = 1000 L)
        unit: "l"
      };
    }

    // Convertir galones a m³ si el valor es >= 1000 (valores muy grandes)
    if (unit === "galon" && value >= 1000) {
      return {
        value: value / 264.172, // Convertir galones a m³ (1 m³ = 264.172 gal)
        unit: "m3"
      };
    }

    return { value, unit };
  };


  useEffect(() => {
    (async () => {
      try {
        // Ordenar descendente y tomar solo los últimos 5 años
        const sortedYears = data.years ? data.years.sort((a, b) => b - a).slice(0, 5) : [];
        setYears(sortedYears);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [data]);

  // Buscar el primer año que tenga unidad definida
  const obtenerUnidadDeOtrosAnios = (datos, concepto) => {
    if (!datos[concepto]) return "";
    const años = Object.keys(datos[concepto]);
    const añoConUnidad = años.find((año) => datos[concepto][año]?.unit);
    return añoConUnidad ? datos[concepto][añoConUnidad].unit : "";
  };

  useEffect(() => {
    (async () => {
      try {
        // Obtener las unidades buscando el primer año con unidad definida
        let valor = {};
        conceptos.map((field) => {
          valor[field] = obtenerUnidadDeOtrosAnios(totales, field);
        });
        setSelectedUnits(valor);
      } catch (error) {
        //console.error(error);
        setSelectedUnits([]);
      }
    })();
  }, [conceptos, totales]);

  useEffect(() => {
    (async () => {
      try {
        setListConceptos(conceptos);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [conceptos]);

  // Función para obtener el icono de aumento o disminución
  const getComparativeIcon = (currentYear, previousYear) => {
    if (previousYear !== null) {
      if (currentYear > previousYear) {
        return <Icon disabled name="angle up" color="green" />; // Aumento
      } else if (currentYear < previousYear) {
        return <Icon disabled name="angle down" color="red" />; // Disminución
      } else if (currentYear === previousYear) {
        return <span style={{ color: "blue", fontWeight: "bold" }}>=</span>;
      }
    }
    return null; // Sin cambio
  };

  // Función para obtener el icono de aumento o disminución
  const getIndicators = (item) => {
    let result = indicatorsLineBase.find((value) => value.name === item);
    if (result) {
      return result?.yearBaseline || 0;
    }
    return 0; // Sin cambio
  };

  // Determina si una fila debe mostrarse como enteros (sin decimales)
  const isIntegerRow = (item) => {
    return item.includes("cost");
  };

  // Determina los decimales necesarios para un valor individual
  const getNeededDecimals = (value) => {
    if (typeof value !== "number" || isNaN(value) || value === 0) return 2;
    const abs = Math.abs(value);
    if (abs < 0.0000005) return -1;
    if (abs >= 1) return 2;
    const leadingZeros = Math.floor(-Math.log10(abs));
    return Math.max(2, leadingZeros + 2);
  };

  // Determina la cantidad de decimales consistente para toda una fila
  const getRowDecimalPlaces = (item, values) => {
    const nonZero = values.filter((v) => typeof v === "number" && !isNaN(v) && v !== 0);
    if (isIntegerRow(item)) {
      if (nonZero.length === 0 || nonZero.every((v) => Math.abs(v) >= 1)) return 0;
    }
    let maxDecimals = 2;
    for (const v of values) {
      if (typeof v !== "number" || isNaN(v) || v === 0) continue;
      const needed = getNeededDecimals(v);
      if (needed === -1) continue;
      if (needed > maxDecimals) maxDecimals = needed;
    }
    return Math.min(maxDecimals, 6);
  };

  // Formatea un valor con la cantidad de decimales determinada para la fila
  const formatWithDecimals = (value, decimals) => {
    if (typeof value !== "number" || isNaN(value)) return "-";
    if (value === 0) return "-";
    if (Math.abs(value) < 0.0000005) return decimals === 0 ? "0" : (0).toFixed(decimals);
    if (decimals === 0) return Math.round(value).toString();
    return value.toFixed(decimals);
  };

  const renderPill = (displayValue, prevDisplayValue, decimals) => {
    const numValue = displayValue != null ? Number(displayValue) : null;
    const numPrev = prevDisplayValue != null ? Number(prevDisplayValue) : null;

    if (numValue == null || numValue === 0) {
      return <span className="gei-value-pill pill-empty" />;
    }

    let pillClass;
    if (numPrev == null || numPrev === 0) {
      pillClass = "pill-neutral";
    } else if (numValue > numPrev) {
      pillClass = "pill-up";
    } else if (numValue < numPrev) {
      pillClass = "pill-down";
    } else {
      pillClass = "pill-neutral";
    }

    return (
      <span className={`gei-value-pill ${pillClass}`}>
        {formatWithDecimals(numValue, decimals)}
      </span>
    );
  };

  return (
    <>
      <Table celled structured size="small" className="gei-kpi-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("indicators")}
            </Table.HeaderCell>
            {years.map((year, index) => (
              <Table.HeaderCell rowSpan="2" textAlign="center" key={index}>
                {year}
              </Table.HeaderCell>
            ))}
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("LB")}
            </Table.HeaderCell>
            <Table.HeaderCell
              rowSpan="2"
              textAlign="center"
              style={{ width: "200px" }}
            >
              {t("units")}
            </Table.HeaderCell>
            {/* <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("MWh equivalentes")}
            </Table.HeaderCell> */}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {conceptos.filter(item => {
            // Verificar si tiene al menos un valor no cero y válido
            if (!totales[item]) return false;
            return Object.values(totales[item]).some(val => val.total && val.total !== 0 && !isNaN(val.total));
          }).map((item, index) => {
            // Recopilar todos los valores de la fila para determinar decimales consistentes
            const rowValues = years
              .map(y => {
                const originalValue = totales[item]?.[y]?.total || 0;
                const originalUnit = totales[item]?.[y]?.unit || "";
                const { value: displayValue } = autoConvertToLiters(originalValue, originalUnit);
                return displayValue;
              })
              .filter(v => typeof v === "number" && !isNaN(v));
            const lbOriginalValue = totales[item]?.[getIndicators(item)]?.total || 0;
            const lbOriginalUnit = totales[item]?.[getIndicators(item)]?.unit || "";
            const { value: lbDisplayValue } = autoConvertToLiters(lbOriginalValue, lbOriginalUnit);
            if (typeof lbDisplayValue === "number" && !isNaN(lbDisplayValue)) rowValues.push(lbDisplayValue);

            const rowDecimals = getRowDecimalPlaces(item, rowValues);

            return (
            <React.Fragment key={index}>
              <Table.Row>
                <Table.Cell>{effluentKPIsCodes[item]}</Table.Cell>
                <Table.Cell>{t(item)}</Table.Cell>
                {years.map((year, i) => {
                  if (totales[item]) {
                    const originalValue = totales[item][year]?.total || 0;
                    const originalUnit = totales[item][year]?.unit || "";
                    const { value: displayValue } = autoConvertToLiters(originalValue, originalUnit);

                    const prevOriginalValue = totales[item][year - 1]?.total || 0;
                    const prevOriginalUnit = totales[item][year - 1]?.unit || "";
                    const { value: prevDisplayValue } = autoConvertToLiters(prevOriginalValue, prevOriginalUnit);

                    const pill = renderPill(displayValue, prevDisplayValue, rowDecimals);
                    return (
                      <Table.Cell key={i} textAlign="center">
                        <Popup
                          content={`Valor real: ${parseFloat(Number(originalValue).toFixed(6))} ${originalUnit}`}
                          trigger={<span style={{ cursor: "help" }}>{pill}</span>}
                          position="top center"
                          size="tiny"
                        />
                      </Table.Cell>
                    );
                  }
                  return <Table.Cell key={i}>{""}</Table.Cell>;
                })}
                <Table.Cell>
                  <Popup
                    content={`Valor real: ${lbOriginalValue} ${lbOriginalUnit}`}
                    trigger={
                      <span style={{ cursor: "help" }}>
                        {formatWithDecimals(lbDisplayValue, rowDecimals)}
                      </span>
                    }
                    position="top center"
                    size="tiny"
                  />
                </Table.Cell>
                <Table.Cell>
                  {/* Unidad - Si se convirtió a litros, mostrar en naranja */}
                  {(() => {
                    const originalValue = totales[item][getIndicators(item)]?.total || 0;
                    const originalUnit = selectedUnits[item] || "";

                    const { unit: displayUnit } = autoConvertToLiters(originalValue, originalUnit);
                    const wasConverted = displayUnit !== originalUnit && originalUnit;

                    // Determinar el sufijo según el tipo de item
                    let suffix = "";
                    if (
                      item === "domestic_effluents_kpis" ||
                      item === "treatment_cost_domestic_effluents_kpis"
                    ) {
                      suffix = ` / ${t("employee")}`;
                    } else if (
                      item === "industrial_effluents_kpis" ||
                      item === "combined_effluents_kpis" ||
                      item === "sludge_and_mud_kpis" ||
                      item === "industrial_effluent_treatment_cost_kpis" ||
                      item === "recycled_effluents_kpis" ||
                      item === "sludge_disposal_cost_kpis"
                    ) {
                      suffix = ` / ${t("unit")}`;
                    }

                    // Si no hay unidad, mostrar "-"
                    if (!originalUnit && !displayUnit) {
                      return "-";
                    }

                    // Si se convirtió a litros, mostrar en naranja con sufijo
                    if (wasConverted) {
                      return <span style={{ color: "#000", fontWeight: "bold" }}>{displayUnit}{suffix}</span>;
                    }

                    return `${originalUnit}${suffix}` || "-";
                  })()}
                  {/* <Dropdown
                      onChange={(e, data) => {
                        handleUnitChange(item, data);
                      }}
                      options={determineEffluentUnits(item).map((ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      })}
                      search
                      inline
                      defaultValue={determineEffluentUnits(item)[0].value}
                    /> */}
                </Table.Cell>

                {/* <Table.Cell> */}
                  {/* {" "}
                    {convertUnitsFinal(
                      totales[item][getIndicators(item)]?.total || 0,
                      totales[item][getIndicators(item)]?.unit,
                      "MWh",
                      item
                    ) || 0} */}
                {/* </Table.Cell> */}
              </Table.Row>
            </React.Fragment>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
});

// 🚀 Memoizar YearMonthSelector
export const YearMonthSelector = React.memo(({ onChange }) => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const years = useMemo(() => [
    { key: currentYear, text: currentYear, value: currentYear },
    { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
    { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
    { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
     { key: currentYear - 4, text: currentYear - 4, value: currentYear - 4 },
  ], [currentYear]);

  const months = useMemo(() => [
    { key: 1, text: "Enero", value: 1 },
    { key: 2, text: "Febrero", value: 2 },
    { key: 3, text: "Marzo", value: 3 },
    { key: 4, text: "Abril", value: 4 },
    { key: 5, text: "Mayo", value: 5 },
    { key: 6, text: "Junio", value: 6 },
    { key: 7, text: "Julio", value: 7 },
    { key: 8, text: "Agosto", value: 8 },
    { key: 9, text: "Septiembre", value: 9 },
    { key: 10, text: "Octubre", value: 10 },
    { key: 11, text: "Noviembre", value: 11 },
    { key: 12, text: "Diciembre", value: 12 },
  ], []);

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-12

  const handleYearChange = useCallback((e, { value }) => {
    setSelectedYear(value);
    onChange({ year: value, month: selectedMonth });
  }, [onChange, selectedMonth]);

  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Dropdown
        placeholder="Año"
        selection
        options={years}
        value={selectedYear}
        onChange={handleYearChange}
        className="year-filter-dropdown"
      />
    </div>
  );
});

function EffluentComparisonChartIndustrial({ resultsByYear , t}) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Object.keys(resultsByYear).sort((a, b) => b - a);

  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    years.forEach((year) => {
      const values = months.map(
        (month) =>
          resultsByYear?.[year]?.[month]?.industrial_effluents?.total || 0
      );

      const avg = values.reduce((a, b) => a + b, 0) / values.length;

      months.forEach((month, i) => {
        const total = values[i];
        bar.push({
          year: String(year),
          month: t(month),
          value: total,
          type: `Consumo ${year}`,
        });
        line.push({
          year: String(year),
          month: t(month),
          value: avg,
          type: `--Promedio ${year}`,
        });
      });
    });

    return { barData: bar, lineData: line };
  }, [resultsByYear]);

  const CustomLegend = () => (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
      {years.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "100px",
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );

  const [activeYears, setActiveYears] = useState(years);

  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };

  const filteredBarData = useMemo(() =>
    barData.filter(d => activeYears.includes(String(d.year))),
  [barData, activeYears]);

  const filteredLineData = useMemo(() =>
    lineData.filter(d => activeYears.includes(String(d.year))),
  [lineData, activeYears]);

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
  };

  const yearColorMap = useMemo(() => {
    const sorted = [...years].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1",
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [years]);

  const config = {
    xField: "month",
    legend: false,
        autoFit: true,
  padding: 'auto', // Deja que la librería calcule el espacio
  appendPadding: [20, 0, 20, 0], // [arriba, derecha, abajo, izquierda]
    scale: {
      color: {
        domain: Object.keys(yearColorMap),
        range: Object.values(yearColorMap),
      },
      y: { sync: true, nice: true, domainMin: 0 },
    },
    tooltip: {
      items: [
        (item) => ({
          name: item.type,
          value: item.value.toFixed(2),
        }),
      ],
    },
    children: [
      {
        data: filteredBarData,
        type: "interval",
        yField: "value",
        colorField: "year",
        seriesField: "year",
        group: true,
        style: { maxWidth: 40 },
        scale: { color: ({ year }) => yearColorMap[year] },
        interaction: { elementHighlight: { background: true } },
      },
      {
        data: filteredLineData,
        type: "line",
        yField: "value",
        colorField: "year",
        style: { lineWidth: 2,
        lineDash: [4, 8]},
        axis: { y: false },
      },
    ],
    axis: {
      x: { title: false, labelAutoHide: false, labelAutoRotate: false, labelFill:"#000" },
      y: { title: false, grid: true,labelFill:"#000" },
    },
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      {barData.length > 0 && <CustomLegend />}
      {barData.length ? (
        <div style={{ height: 350 }}>
          <DualAxes {...config} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 350, color: "#999" }}>
          No hay datos disponibles
        </div>
      )}
    </div>
  );
}

function EffluentMonthlyChartIndustrial({ resultsByYear , t, resultsProductions}) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Object.keys(resultsByYear).sort((a, b) => b - a);

  const { consumptionData, averageData } = useMemo(() => {
    const cData = [];
    const aData = [];

    years.forEach((year) => {
      const totals = months.map((m) => {
        const effluent = resultsByYear?.[year]?.[m]?.industrial_effluents?.total || 0;
        const production = resultsProductions?.[year]?.[m] || 0;
        return production > 0 ? effluent / production : 0;
      });
      const validValues = totals.filter((v) => v !== null && !isNaN(v) && v > 0);
      const avg = validValues.length > 0 ? validValues.reduce((a, b) => a + b, 0) / validValues.length : 0;

      months.forEach((month, i) => {
        cData.push({
          year: String(year),
          month: t(month),
          value: totals[i],
          tipo: "Consumo",
          type: `Consumo ${year}`,
        });
        aData.push({
          year: String(year),
          month: t(month),
          value: validValues.length > 0 ? avg : null,
          tipo: "Promedio",
          type: `--Promedio ${year}`,
        });
      });
    });

    return { consumptionData: cData, averageData: aData };
  }, [resultsByYear, resultsProductions]);

  const CustomLegend = () => (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
      {years.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "100px",
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );

  const [activeYears, setActiveYears] = useState(years);

  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };

  const filteredConsumptionData = useMemo(() =>
    consumptionData.filter(d => activeYears.includes(String(d.year))),
  [consumptionData, activeYears]);

  const filteredAverageData = useMemo(() =>
    averageData.filter(d => activeYears.includes(String(d.year))),
  [averageData, activeYears]);

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
  };

  const yearColorMap = useMemo(() => {
    const sorted = [...years].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1",
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [years]);

  const config = {
    xField: "month",
    legend: false,
    scale: {
      color: {
        domain: Object.keys(yearColorMap),
        range: Object.values(yearColorMap),
      },
    },
    tooltip: {
      shared: true,
      items: [
        (item) => ({
          name: item.type,
          value: item.value !== null ? item.value.toFixed(2) : "-",
          color: yearColorMap[item.year],
        }),
      ],
    },
    children: [
      {
        data: filteredConsumptionData,
        type: "line",
        yField: "value",
        colorField: "year",
        connectNulls: false,
        style: { lineWidth: 4 },
      },
      {
        data: filteredAverageData,
        type: "line",
        yField: "value",
        colorField: "year",
        axis: { y: false },
        style: { lineWidth: 2, lineDash: [4, 8] },
        connectNulls: false,
      },
    ],
    axis: {
      x: { title: false, labelAutoHide: false, labelAutoRotate: false },
      y: { title: false, grid: true },
    },
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      {consumptionData.length > 0 && <CustomLegend />}
      {consumptionData.length ? (
        <div style={{ height: 450 }}>
          <DualAxes {...config} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 450, color: "#999" }}>
          No hay datos disponibles
        </div>
      )}
    </div>
  );
}

function EffluentComparisonChartDomestic({ resultsByYear, t }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Object.keys(resultsByYear).sort((a, b) => b - a);

  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    years.forEach((year) => {
      const values = months.map(
        (month) =>
          resultsByYear?.[year]?.[month]?.domestic_effluents?.total || 0
      );

      const avg = values.reduce((a, b) => a + b, 0) / values.length;

      months.forEach((month, i) => {
        const total = values[i];
        bar.push({
          year: String(year),
          month: t(month),
          value: total,
          type: `Consumo ${year}`,
        });
        line.push({
          year: String(year),
          month: t(month),
          value: avg,
          type: `--Promedio ${year}`,
        });
      });
    });

    return { barData: bar, lineData: line };
  }, [resultsByYear]);

  const CustomLegend = () => (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
      {years.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "100px",
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );

  const [activeYears, setActiveYears] = useState(years);

  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };

  const filteredBarData = useMemo(() =>
    barData.filter(d => activeYears.includes(String(d.year))),
  [barData, activeYears]);

  const filteredLineData = useMemo(() =>
    lineData.filter(d => activeYears.includes(String(d.year))),
  [lineData, activeYears]);

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
  };

  const yearColorMap = useMemo(() => {
    const sorted = [...years].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1",
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [years]);

  const config = {
    xField: "month",
    legend: false,
        autoFit: true,
  padding: 'auto', // Deja que la librería calcule el espacio
  appendPadding: [20, 0, 20, 0], // [arriba, derecha, abajo, izquierda]
    scale: {
      color: {
        domain: Object.keys(yearColorMap),
        range: Object.values(yearColorMap),
      },
        y: { sync: true, nice: true, domainMin: 0 },
    },
    tooltip: {
      items: [
        (item) => ({
          name: item.type,
          value: item.value.toFixed(2),
        }),
      ],
    },
    children: [
      {
        data: filteredBarData,
        type: "interval",
        yField: "value",
        colorField: "year",
        seriesField: "year",
        group: true,
        style: { maxWidth: 40 },
        scale: { color: ({ year }) => yearColorMap[year] },
        interaction: { elementHighlight: { background: true } },
      },
      {
        data: filteredLineData,
        type: "line",
        yField: "value",
        colorField: "year",
        style: { lineWidth: 2, lineDash: [4, 8] },
        axis: { y: false },
      },
    ],
    axis: {
      x: { title: false, labelAutoHide: false, labelAutoRotate: false,labelFill:"#000" },
      y: { title: false, grid: true ,labelFill:"#000"},
    },
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      {barData.length > 0 && <CustomLegend />}
      {barData.length ? (
        <div style={{ height: 350 }}>
          <DualAxes {...config} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 350, color: "#999" }}>
          No hay datos disponibles
        </div>
      )}
    </div>
  );
}

function EffluentMonthlyChartDomestic({ resultsByYear , t, resultsProductions, resultsWorkers }) {
  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  const allYears = Object.keys(resultsByYear).sort((a, b) => b - a);
  const years = allYears.slice(0, 3);

  const { consumptionData, averageData } = useMemo(() => {
    const cData = [];
    const aData = [];

    years.forEach((year) => {
      const totals = months.map((m) => {
        const effluent = resultsByYear?.[year]?.[m]?.domestic_effluents?.total || 0;
        const workers = resultsWorkers?.[year]?.[m] || 0;
        return workers > 0 ? effluent / workers : 0;
      });
      const validValues = totals.filter((v) => v !== null && !isNaN(v) && v > 0);
      const avg = validValues.length > 0 ? validValues.reduce((a, b) => a + b, 0) / validValues.length : 0;

      months.forEach((month, i) => {
        cData.push({
          year: String(year),
          month: t(month),
          value: totals[i],
          tipo: "Consumo",
          type: `Consumo ${year}`,
        });
        aData.push({
          year: String(year),
          month: t(month),
          value: validValues.length > 0 ? avg : null,
          tipo: "Promedio",
          type: `--Promedio ${year}`,
        });
      });
    });

    return { consumptionData: cData, averageData: aData };
  }, [resultsByYear, resultsWorkers]);

  const CustomLegend = () => (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginBottom: "20px", paddingLeft: "5px", flexWrap: "wrap" }}>
      {years.map((year) => {
        const isActive = activeYears.includes(year);
        return (
          <div
            key={year}
            onClick={() => toggleYear(year)}
            style={{
              backgroundColor: isActive ? yearColorMap[year] : "#f3f4f6",
              color: isActive ? "white" : "#9ca3af",
              padding: "4px 20px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              border: isActive ? `1px solid ${yearColorMap[year]}` : "1px solid #d1d5db",
              boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "100px",
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );

  const [activeYears, setActiveYears] = useState(years);

  const toggleYear = (year) => {
    if (activeYears.includes(year)) {
      setActiveYears(activeYears.filter(y => y !== year));
    } else {
      setActiveYears([...activeYears, year]);
    }
  };

  const filteredConsumptionData = useMemo(() =>
    consumptionData.filter(d => activeYears.includes(String(d.year))),
  [consumptionData, activeYears]);

  const filteredAverageData = useMemo(() =>
    averageData.filter(d => activeYears.includes(String(d.year))),
  [averageData, activeYears]);

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const chartColors = {
    oldest: getCssVar("--chart-year-oldest"),
    prev: getCssVar("--chart-year-prev"),
    last: getCssVar("--chart-year-last"),
  };

  const yearColorMap = useMemo(() => {
    const sorted = [...years].map(Number).sort((a, b) => a - b);
    return {
      [sorted[0]]: chartColors.oldest || "#cbd5e1",
      [sorted[1]]: chartColors.prev || "#94a3b8",
      [sorted[2]]: chartColors.last || "#1e293b",
    };
  }, [years]);

  const config = {
    xField: "month",
    legend: false,
    scale: {
      color: {
        domain: Object.keys(yearColorMap),
        range: Object.values(yearColorMap),
      },
    },
    tooltip: {
      shared: true,
      items: [
        (item) => ({
          name: item.type,
          value: item.value !== null ? item.value.toFixed(2) : "-",
          color: yearColorMap[item.year],
        }),
      ],
    },
    children: [
      {
        data: filteredConsumptionData,
        type: "line",
        yField: "value",
        colorField: "year",
        connectNulls: false,
        style: { lineWidth: 4 },
      },
      {
        data: filteredAverageData,
        type: "line",
        yField: "value",
        colorField: "year",
        axis: { y: false },
        style: { lineWidth: 2, lineDash: [4, 8] },
        connectNulls: false,
      },
    ],
    axis: {
      x: { title: false, labelAutoHide: false, labelAutoRotate: false },
      y: { title: false, grid: true },
    },
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      {consumptionData.length > 0 && <CustomLegend />}
      {consumptionData.length ? (
        <div style={{ height: 450 }}>
          <DualAxes {...config} />
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 450, color: "#999" }}>
          No hay datos disponibles
        </div>
      )}
    </div>
  );
}

// Componente para mostrar valores intermedios utilizados en los cálculos
function IntermediateValuesDisplay({ resultsProductions, resultsWorkers, t }) {
  const [isOpen, setIsOpen] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Obtener todos los años disponibles y ordenarlos de mayor a menor
  const availableYears = Object.keys(resultsProductions || {}).sort(
    (a, b) => b - a
  );

  return (
    <div
      style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #dee2e6",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: "10px 0",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h4 style={{ margin: 0, color: "#495057" }}>
          <Icon name={isOpen ? "chevron down" : "chevron right"} />
          Valores intermedios para verificación de cálculos - Últimos 5 años
        </h4>
        <span style={{ fontSize: "0.9em", color: "#6c757d" }}>
          {isOpen ? "Haz clic para ocultar" : "Haz clic para ver detalles"}
        </span>
      </div>

      {isOpen && (
        <>
          {availableYears.map((year) => (
            <div key={year} style={{ marginBottom: "30px" }}>
              <h5
                style={{
                  marginTop: "20px",
                  marginBottom: "10px",
                  color: "#495057",
                }}
              >
                Año {year}
              </h5>
              <Table celled size="small" style={{ fontSize: "0.9em" }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign="center">Mes</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Producción (VPS/VFS)
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Trabajadores
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {months.map((month) => {
                    const production = resultsProductions?.[year]?.[month] || 0;
                    const workers = resultsWorkers?.[year]?.[month] || 0;

                    return (
                      <Table.Row key={month}>
                        <Table.Cell textAlign="center">
                          {t ? t(month) : month}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {production > 0 ? production.toFixed(2) : "-"}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {workers > 0 ? workers : "-"}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                  <Table.Row
                    style={{ fontWeight: "bold", backgroundColor: "#e9ecef" }}
                  >
                    <Table.Cell textAlign="center">Total</Table.Cell>
                    <Table.Cell textAlign="center">
                      {Object.values(resultsProductions?.[year] || {})
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {Object.values(resultsWorkers?.[year] || {}).reduce(
                        (a, b) => a + b,
                        0
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row
                    style={{ fontWeight: "bold", backgroundColor: "#d1ecf1", color: "#0c5460" }}
                  >
                    <Table.Cell textAlign="center">Promedio</Table.Cell>
                    <Table.Cell textAlign="center">
                      {(() => {
                        const values = Object.values(resultsProductions?.[year] || {});
                        const count = values.filter(v => v > 0).length;
                        const avg = count > 0 ? values.reduce((a, b) => a + b, 0) / count : 0;
                        return avg.toFixed(2);
                      })()}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {(() => {
                        const values = Object.values(resultsWorkers?.[year] || {});
                        const count = values.filter(v => v > 0).length;
                        const avg = count > 0 ? values.reduce((a, b) => a + b, 0) / count : 0;
                        return avg.toFixed(0);
                      })()}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
          ))}

          <div
            style={{
              fontSize: "0.85em",
              color: "#6c757d",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            <strong>Nota:</strong> Estos valores se utilizan como denominadores
            en los cálculos de intensidad. Producción (VPS/VFS) para intensidad
            industrial y Trabajadores para intensidad doméstica.
          </div>
        </>
      )}
    </div>
  );
}
